/** [install description]common methods 全局通用函数*/
// var store = require('../store');
exports.install = function(Vue) {
  /** [ajax description]请求封装post */
  Vue.prototype.ajaxPost = function(options) {
    let _this = this;
    _this.$http.post(options.url, options.data, {
      emulateJSON: true
    }).then(function (response) {
      return response.json();
    }, function (response) {
      if (typeof options.error == 'function') {
        options.error();
      }
    }).then(function (data) {
      try{
        /** [if description]request success */
        if (data.code === 3001) {
          if (typeof options.success == 'function') {
            options.success(data);
          }
        } else if (data.code == 5008 || data.code == 5110 || data.code == 5011) {
            if (data.code == 5008) {
              window.location.href=data.data.url;//请在微信客户端中打开
            }
        } else {
          if (!options.closeErrorInfo) {
            _this.$message({
              showClose: true,
              message: data.msg,
              type: 'error',
              center:true
            });

          }
          if (typeof options.error == 'function') {
            options.error(data);
          }
        }
      }catch(e){
        console.log(e)
        _this.$message({
              showClose: true,
              message: data.msg,
              type: 'error',
              center:true
        });
      }
    });
  };

  /** [ajax description]请求封装get */
  Vue.prototype.Get = function(options) {
    let _this = this;
    _this.$http.get(options.url,{
      params:options.data,
      emulateJSON: true
    }).then(function (response) {
      return response.data;
    }, function (response) {
      if (typeof options.error == 'function') {
        options.error();
      }
    }).then(function (data) {
      try {
        /** [if description]request success */
        if (data.code === 3001) {
          if (typeof options.success == 'function') {
            options.success(data);
          }
        } else if (data.code == 4007) {

        } else if (data.code == 5129 ||data.code == 5008 || data.code == 5110 ||data.code==5007 || data.code == 5011||data.code==5107||data.code==5013||data.code==5014||data.code==5020||data.code==5023||data.code==5108||data.code==5009||data.code==5124||data.code==5025||data.code==5026||data.code==5012) { //||data.code==5007
            if (data.code == 5008) {
              window.location.href = data.data.url;//请在微信客户端中打开
            }else{
              if (typeof options.error == 'function') {
                options.error(data);
              }else{
                _this.$message({
                  type: 'error',
                  message: data.msg,
                  center:true
                });
              }
            }
        } else {
          _this.$message({
            type: 'error',
            message: data.msg,
            center:true
          });
        }
      } catch(e){
        console.log(e)
        _this.$message({
              showClose: true,
              message: data.msg,
              type: 'error',
              center:true
        });
      }
    });
  };

  /** [formatDate description]格式化时间 --start--- */
  function padLeftZero(str) {
    return ('00' + str).substr(str.length);
  }
  Vue.prototype.formatDate = function(date, fmt) {
    if (!date) return '';
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
      }
    }
    return fmt;
  };
  /** [formatDate description]格式化时间 --end--- */

  /** [ArrayToString description]数组转字符串 */
  Vue.prototype.ArrayToString = function(arr, symbol, label) {
    let len = arr.length,
      c_arr = [];
    if (len) {
      for (let i = 0; i < len; i++) {
        let item = arr[i];
        if (item) {
          if (label) {
            c_arr.push(item[label])
          } else {
            c_arr.push(item);
          }
        }
      }
    }
    return c_arr.join(symbol);
  }
};




// WEBPACK FOOTER //
// ./src/assets/js/getData.js